import React, { useContext, useLayoutEffect, useRef } from 'react';
import { useTranslation } from 'react-i18next';
import { NoDataComponent } from '../NoDataComponent';
import { NewRequestContext } from '../../context/NewRequestContext';

export const ClientBranches = () => {
    const { t } = useTranslation('translation', { keyPrefix: 'common' });

    const { setshowOnlyClient, onBranchSelect, selectedBranchId, selectedClientId, clientBranches: branches } =
        useContext(NewRequestContext);

    const selectRef = useRef<HTMLSelectElement>(null);
    const selectedValue = String(selectedBranchId ?? 0);

    // Preserve native listbox navigation across background data refreshes.
    // Only an identity change should synchronize an already mounted selection.
    useLayoutEffect(() => {
        if (selectRef.current && selectRef.current.value !== selectedValue) {
            selectRef.current.value = selectedValue;
        }
    }, [selectedValue, selectedClientId]);

    const selectBranch = (id: string) => {
        if (Number(id)) {
            const branchFromList = branches?.items.find(branch => Number(branch.id) === Number(id));

            if (!branchFromList) {
                return;
            }

            // Commit user intent immediately. useFreshRequestBranch refreshes the snapshot
            // separately; server responses must never change the selected identity.
            onBranchSelect(branchFromList);
            setshowOnlyClient(false);
        } else {
            onBranchSelect(null);
            setshowOnlyClient(true);
        }
    };

    const branchCount = (branches?.items?.length ?? 0) + 1;
    const selectSize = Math.min(Math.max(branchCount, 2), 7);

    return (
        <div className='w-100 align-items-top justify-content-end text-center'>
            <h5 className='mb-3'>{t('branches') + ':'}</h5>
            <div className={'mx-2 border border-dark'}>
                {branches?.items && branches?.items.length > 0 ? (
                    <select
                        key={selectedClientId}
                        ref={selectRef}
                        defaultValue={selectedValue}
                        className='form-control branches-select'
                        id='branches'
                        size={selectSize}
                        onChange={(e) => selectBranch(e.target.value)}
                    >
                        <option key={0} value={0}>
                            {t('AllBranches')}
                        </option>
                        {branches?.items.concat().map((branch) => (
                            <option key={branch.id} id={String(branch.id)} value={branch.id}>
                                {branch.name + ', ' + branch.location.city + ', ' + branch.location.address}
                            </option>
                        ))}
                    </select>
                ) : (
                    <div className='h-100 d-flex align-items-center w-100 px-2'>
                        <NoDataComponent noDataText={t('branches')}></NoDataComponent>
                    </div>
                )}
            </div>
        </div>
    );
};
